import {useEffect, useState} from 'react';

export const useCountdownTimer = (targetDate?: Date) => {
  const [, setTick] = useState(0);

  useEffect(() => {
    if (targetDate === undefined) return;

    const interval = setInterval(() => {
      setTick(t => t + 1);
    }, 1000);

    return () => clearInterval(interval);
  }, [targetDate]);

  if (targetDate === undefined) {
    return [0, 0, 0, 0];
  }

  const countDown =
    convertUTCDateToLocalDate(new Date(targetDate)).getTime() -
    new Date().getTime();

  return getReturnValues(countDown);
};

const convertUTCDateToLocalDate = (date: Date): Date => {
  const newDate = new Date(
    date.getTime() - date.getTimezoneOffset() * 60 * 1000
  );
  return newDate;
};

export const getReturnValues = (countDown: number) => {
  const days = Math.floor(countDown / (1000 * 60 * 60 * 24));
  const hours = Math.floor(
    (countDown % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
  );
  const minutes = Math.floor((countDown % (1000 * 60 * 60)) / (1000 * 60));
  const seconds = Math.floor((countDown % (1000 * 60)) / 1000);

  return [days, hours, minutes, seconds];
};
